module.exports = __webpack_public_path__ + "img/paihangbang@2x.dddb635f.png";